export const rateCategories = {
  OTA: 'OTA',
  Direct: 'Direct',
  FriendsAndFamily: 'FriendsAndFamily',
  CorporateLocal: 'CorporateLocal',
  CorporateBrand: 'CorporateBrand',
  GovernmentLocal: 'GovernmentLocal',
  GovernmentBrand: 'GovernmentBrand',
  Complimentary: 'Complimentary',
  RewardPointsClaim: 'RewardPointsClaim',
  LongTermResident: 'LongTermResident',
  DiscountLocal: 'DiscountLocal',
  DiscountBrand: 'DiscountBrand',
  WalkIn: 'WalkIn',
  AAA: 'AAA'
}

export const rateCategoryNames = {
  OTA: 'OTA',
  Direct: 'Direct',
  FriendsAndFamily: 'Friends & family',
  CorporateLocal: 'Corporate local',
  CorporateBrand: 'Corporate brand',
  GovernmentLocal: 'Government local',
  GovernmentBrand: 'Government brand',
  Complimentary: 'Complimentary',
  RewardPointsClaim: 'Reward points',
  LongTermResident: 'Long term resident',
  DiscountLocal: 'Discount local',
  DiscountBrand: 'Discount brand',
  WalkIn: 'Walk-in',
  AAA: 'AAA'
}

export const rateCategoryNamesNew = {
  OTA: 'OTA',
  FriendsAndFamily: 'Friends & family',
  Complimentary: 'Complimentary',
  DiscountClub: 'Discount club (AAA, ARP, etc.)',
  CorporateLocal: 'Corporate local',
  GovernmentLocal: 'Government local',
  RewardPointsClaim: 'Reward points',
  LongTermResident: 'Long term resident',
  DiscountLocal: 'Discount local',
  DiscountBrand: 'Discount brand'
}
